export enum Scope {
  PROFILE = 'profile',
  EMAIL = 'email',
  GMAIL = 'https://www.googleapis.com/auth/gmail.labels',
  OPENID = 'openid'
}
